var React = require('react');

function Warning (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-19 -19)"},[React.createElement("path",{"d":"M43,19A24,24,0,1,0,67,43,24,24,0,0,0,43,19Zm0,43.355A19.355,19.355,0,1,1,62.355,43,19.355,19.355,0,0,1,43,62.355Z","fill":"#282d3d","key":0}),React.createElement("rect",{"width":"4","height":"13","transform":"translate(41 31)","fill":"#282d3d","key":1}),React.createElement("circle",{"cx":"2.5","cy":"2.5","r":"2.5","transform":"translate(40.5 50)","fill":"#282d3d","key":2})]));
}

Warning.defaultProps = {"focusable":"false","viewBox":"0 0 48 48"};

module.exports = Warning;

Warning.default = Warning;
